import { CasinoActionType, CasinoState, SET_CASINO_NET_POSITION } from '../types/casinoTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialCasinoState: CasinoState = {
  casinoNetPosition: 0,
};

export const casinoReducer = (state = initialCasinoState, action: CasinoActionType): CasinoState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialCasinoState,
      };
    case SET_CASINO_NET_POSITION: {
      return { ...state, casinoNetPosition: action.meta };
    }
    default:
      return state;
  }
};
